export default (name, url = window.location.href) => {
  let results = new RegExp(`[#&]${name}=([^&#]*)`).exec(url);
  if (results !== null) {
    return decodeURIComponent(results[1]);
  }

  results = new RegExp(`[#&]${name}[&#]*`).exec(url);
  return results !== null;
};
